/* eslint-disable @typescript-eslint/no-unused-vars */
import { usePopUpsV2 } from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { usePopupsState } from "hooks";
import { useImagePath } from "hooks/useImagePath";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { usePostMetadataMutation } from "redux/apis";
import { InfoIcon } from "utils/svgIcons";
import { Container, InfoButton, Title } from "../FriendShop/styles";
import { useMediaQuery } from "@mui/material";
import { friendCenterAssets } from "assets/cdn";

const FriendInvite = () => {
	const { getImage } = useImagePath("cdn");
	const isLandscape = useMediaQuery("(orientation: landscape)");
	const isLargeViewport = useMediaQuery("(min-width: 900px)");
	const inviteBackgroundImage = getImage(
		isLandscape || isLargeViewport
			? friendCenterAssets.friendInvite.backgroundLarge
			: friendCenterAssets.friendInvite.background
	);
	const { open } = usePopUpsV2();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { userTracker, syncUserTracker } = useWebStoreContext();
	const { isAnyPopupOpen, hasSeenRequiredPageTutorial, isSignupChecking } =
		usePopupsState();
	const invite = window.location.pathname.endsWith(
		"/friend-center/invite/progress"
	)
		? "invite"
		: "";
	const [hasSeenFriendInviteFtue, setHasSeenFriendInviteFtue] =
		useState<boolean>(false);
	const [
		postMetadata,
		{ isLoading: isSavingFriendInviteFtue, isSuccess: hasSavedFriendInviteFtue }
	] = usePostMetadataMutation({ fixedCacheKey: "friend-invite-ftue-metadata" });

	const handleInfoClick = () => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "web_friend_referral_tutorial",
			event_type: "friend_referral_ui",
			action: "tutorial_display",
			source: "web_friend_referral"
		});
		open({
			variant: "friend-shop-info-popup",
			id: "friend-invite-info-popup",
			replaceIfExists: true
		});
	};

	// *Trigger FTUE popup on first visit
	useEffect(() => {
		if (
			!userTracker?.metadata?.hasDisplayedFriendInviteFtue &&
			hasSeenRequiredPageTutorial &&
			!hasSavedFriendInviteFtue &&
			!isSavingFriendInviteFtue &&
			!hasSeenFriendInviteFtue &&
			!isSignupChecking &&
			!isAnyPopupOpen
		) {
			postMetadata({
				key: "hasDisplayedFriendInviteFtue",
				value: "true"
			})
				.unwrap()
				.then(() => {
					setHasSeenFriendInviteFtue(true);
					handleInfoClick();
				})
				.finally(() => {
					syncUserTracker();
				});
		}
	}, [
		userTracker?.metadata?.hasDisplayedFriendInviteFtue,
		hasSeenRequiredPageTutorial,
		hasSavedFriendInviteFtue,
		isSavingFriendInviteFtue,
		hasSeenFriendInviteFtue,
		isSignupChecking,
		isAnyPopupOpen
	]);

	return (
		<Container
			className={invite}
			$inviteBackgroundImage={inviteBackgroundImage}
		>
			<Title className="invite">
				<span>INVITE FRIENDS TO WEB!</span>
			</Title>
			<InfoButton aria-label="open info popup" onClick={handleInfoClick}>
				<InfoIcon width={35} height={35} />
			</InfoButton>
			<Outlet />
		</Container>
	);
};

export default FriendInvite;
